import _ from 'lodash';

export const incrementStep = () => (dispatch, getState) => {
  const { step = 1 } = getState();
  setStep(step + 1)(dispatch, getState);
};

export const submitForm = () => (dispatch, getState) => {
  dispatch({
    type: 'DISABLE_SUBMIT_BTN',
    disableSubmitBtn: true,
  });

  const { appData } = getState();

  let fData = getState().formData;
  let { contractorAddress } = fData;
  if (fData.registrantType === 'contractor') {
    contractorAddress = {
      ...fData.contractorAddress,
      first_name: fData.contractorFirstName,
      last_name: fData.contractorLastName,
      business_phone: fData.contractorPhone,
      company_name: fData.contractorCompanyName,
    };
  }
  const propertyAddress = {
    ...fData.propertyAddress,
    first_name: fData.propertyOwnerFName,
    last_name: fData.propertyOwnerLName,
    business_phone: fData.homeownerPhone,
  };

  fData = {
    ...fData,
    contractorAddress,
    propertyAddress,
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(fData),
  };
  fetch(`${MDMS_URL}/api/v1/external/warranty_registrations`, requestOptions)
    .then(response => response.json())
    .then(jsonData => {
      appData.registration = jsonData;
    })
    .catch(err => {
      appData.registration = null;
      console.log(err);
      dispatch({ type: 'DISABLE_SUBMIT_BTN', disableSubmitBtn: false });
    })
    .finally(() => {
      dispatch({ type: 'DISABLE_SUBMIT_BTN', disableSubmitBtn: false });
      dispatch(setAppData({ registration: appData.registration }));
      incrementStep()(dispatch, getState);
    });
};

export const decrementStep = () => (dispatch, getState) => {
  const { step = 1 } = getState();
  setStep(step - 1)(dispatch, getState);
};

export const showModal = () => dispatch => {
  dispatch({
    type: 'SHOW_MODAL',
    showModal: true,
  });
};

export const showErrorModal = () => dispatch => {
  dispatch({
    type: 'SHOW_ERROR_MODAL',
    showErrorModal: true,
  });
};

export const hideModal = () => dispatch => {
  dispatch({
    type: 'SHOW_MODAL',
    showModal: false,
  });
};

export const hideErrorModal = () => dispatch => {
  dispatch({
    type: 'SHOW_ERROR_MODAL',
    showErrorModal: false,
  });
};

export const setStep = newStep => (dispatch, getState) => {
  const { step } = getState();
  if (step != newStep) {
    dispatch({
      type: 'SET_STEP',
      stepNum: newStep,
    });
  }
};

export const setFormData = hash => (dispatch, getState) => {
  dispatch({
    type: 'SET_FORM_DATA',
    hash,
  });
};

export const setAppData = hash => dispatch => {
  dispatch({
    type: 'SET_APP_DATA',
    hash,
  });
};

export const pqsPropertyLookup = () => (dispatch, getState) => {
  const { formData, step, metadata } = getState();
  const property = formData.propertyAddress;

  const body = JSON.stringify({
    property_info: {
      first_name: formData.propertyOwnerFName,
      last_name: formData.propertyOwnerLName,
      address_line_1: property.street,
      address_line_2: property.streetLine2,
      city: property.city,
      state: property.state,
      country: property.country,
      zip_code: property.zip,
    },
  });

  fetch(`${MDMS_URL}/api/v1/contractor/warranties/lookup`, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body,
  })
    .then(response => response.json())
    .then(jsonData => {
      metadata.propertyOwnerInfo = jsonData;
    })
    .catch(err => {
      metadata.propertyOwnerInfo = null;
      console.log(err);
      dispatch({
        type: 'IS_FETCHING',
        isFetching: false,
      });
    })
    .finally(() => {
      dispatch({ type: 'IS_FETCHING', isFetching: false });
      dispatch(setFormData({ hasExistingWarranty: !!metadata.propertyOwnerInfo?.warranty_registration_number }));
      dispatch({
        type: 'SHOW_MODAL',
        showModal: true,
      });
    });
};

export const verifyAddress = () => (dispatch, getState) => {
  const { formData, step, metadata } = getState();
  const property = formData.propertyAddress;

  dispatch({
    type: 'IS_FETCHING',
    isFetching: true,
  });

  fetch(`${MDMS_URL}/api/v1/smarty/verification`, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      street_1: property.street,
      street_2: property.streetLine2,
      city: property.city,
      state_province: property.state,
      country_code: property.country,
      postal_code: property.zip,
    }),
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return Promise.reject(response);
    })
    .then(jsonData => {
      metadata.suggestedProperty = {
        street: jsonData.street_1,
        streetLine2: jsonData.street_2,
        city: jsonData.city,
        state: jsonData.state_province,
        zip: jsonData.postal_code,
      };
    })
    .catch(err => {
      dispatch({
        type: 'IS_FETCHING',
        isFetching: false,
      });
      metadata.suggestedProperty = [];
      metadata.suggestedOwner = [];
      console.log(err);
    })
    .finally(() => {
      dispatch(pqsPropertyLookup());
    });
};
